// extracted by mini-css-extract-plugin
module.exports = {"section_toolkit":"toolkit_section_toolkit__nTnqZ","card_wrapper":"toolkit_card_wrapper__a4TE8","border_right":"toolkit_border_right__p_GDP"};